import api, { fmtTRY } from "../../lib/api";
import { toast } from "sonner";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Switch } from "../ui/switch";
import { Trash2, Repeat } from "lucide-react";
import { METHOD } from "./constants";

export default function RecurringExpenses({ items, onChanged }) {
  const toggle = async (r, active) => {
    const { id, created_at, updated_at, last_generated_month, ...rest } = r;
    try { await api.put(`/recurring-expenses/${id}`, { ...rest, active }); toast.success(active ? "Aktifleştirildi" : "Durduruldu"); onChanged(); }
    catch { toast.error("Güncellenemedi"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Tekrarlayan gider silinsin mi? (Geçmiş kayıtlar silinmez)")) return;
    await api.delete(`/recurring-expenses/${id}`); toast.success("Silindi"); onChanged();
  };

  return (
    <Card className="border-slate-200" data-testid="recurring-expenses">
      <CardContent className="p-4">
        <div className="flex items-center gap-2 font-bold text-slate-900 mb-3"><Repeat size={16} className="text-[#D97706]" /> Aylık Tekrarlayan Giderler</div>
        {items.length === 0 ? (
          <div className="text-sm text-slate-500 py-6 text-center">Tekrarlayan gider yok. Yeni gider eklerken "Her ay tekrarla"yı açın.</div>
        ) : (
          <ul className="divide-y divide-slate-100">
            {items.map((r) => (
              <li key={r.id} className="py-2.5 flex items-center justify-between gap-3" data-testid={`recurring-row-${r.id}`}>
                <div className="min-w-0">
                  <div className="font-semibold text-sm truncate">{r.category} · {fmtTRY(r.amount)}</div>
                  <div className="text-xs text-slate-500 truncate">Her ayın {r.day_of_month}. günü · {METHOD[r.payment_method]}{r.description ? ` · ${r.description}` : ""}</div>
                </div>
                <div className="flex items-center gap-1 shrink-0">
                  <Switch checked={r.active} onCheckedChange={(v) => toggle(r, v)} data-testid={`recurring-toggle-${r.id}`} />
                  <Button size="icon" variant="ghost" onClick={() => remove(r.id)} data-testid={`recurring-delete-${r.id}`}><Trash2 size={14} className="text-rose-600" /></Button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
